var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        { staticClass: "mb-16" },
        [
          _c(
            "el-col",
            { attrs: { span: 14 } },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "auth",
                      rawName: "v-auth",
                      value: "customer::customer-manager::tag-add",
                      expression: "'customer::customer-manager::tag-add'",
                    },
                  ],
                  staticClass: "new-menu-item",
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.visiable = true
                    },
                  },
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("customer::customer-manager::tag_add")) +
                      " "
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-row",
        { staticClass: "card-box", attrs: { gutter: 24 } },
        [
          _c(
            "el-col",
            { attrs: { span: 24 } },
            [
              _c("z-table", {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loading,
                    expression: "loading",
                  },
                ],
                attrs: {
                  columns: _vm.columns,
                  data: _vm.tableData,
                  "max-height": 600,
                  pagination: false,
                  customDefault: {
                    desc: _vm.$t("system::common::tips::quick_setting"),
                    buttons: [
                      {
                        btnClick: _vm.initCustomerTag,
                        text: _vm.$t("customer::customer-manager::tag_init"),
                        type: "text",
                      },
                    ],
                  },
                },
                scopedSlots: _vm._u([
                  {
                    key: "operate",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c(
                          "span",
                          [
                            _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "auth",
                                    rawName: "v-auth",
                                    value:
                                      "customer::customer-manager::tag-edit",
                                    expression:
                                      "'customer::customer-manager::tag-edit'",
                                  },
                                ],
                                attrs: { type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleEdit(row)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t("customer::customer-manager::edit")
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                            _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "auth",
                                    rawName: "v-auth",
                                    value:
                                      "customer::customer-manager::tag-delete",
                                    expression:
                                      "'customer::customer-manager::tag-delete'",
                                  },
                                ],
                                staticStyle: { color: "red" },
                                attrs: { type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleDel(row)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t(
                                        "customer::customer-manager::delete"
                                      )
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title:
              "" +
              (_vm.editId
                ? _vm.$t("customer::customer-manager::tag_edit")
                : _vm.$t("customer::customer-manager::tag_add")),
            visible: _vm.visiable,
            "close-on-click-modal": false,
            width: "500px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.visiable = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                model: _vm.params,
                rules: _vm.rules,
                "label-width": "80px",
              },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("customer::customer-manager::tag"),
                    prop: "name",
                  },
                },
                [
                  _c("el-input", {
                    attrs: { maxlength: 20 },
                    nativeOn: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.addTag.apply(null, arguments)
                      },
                    },
                    model: {
                      value: _vm.params.name,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.params,
                          "name",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "params.name",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.visiable = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("customer::customer-manager::cancel")))]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.saveLoading,
                      expression: "saveLoading",
                    },
                  ],
                  attrs: { type: "primary" },
                  on: { click: _vm.addTag },
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("customer::customer-manager::confirm")) +
                      " "
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }